<template>
  <component :is="contractData === undefined ? 'div' : 'b-card'">

    <b-alert variant="danger" :show="contractData === undefined">
      <h4 class="alert-heading">獲取供款表數據時出錯</h4>
      <div class="alert-body">
        找不到相關供款表記錄。請查看
        <b-link class="alert-link" :to="{ name: 'contracts-list' }">
          合約清單
        </b-link>
      </div>
    </b-alert>
    <contract-schedule-edit-tab-information
      v-if="contractData"
      :contract-data="contractData"
      :supplier-options="supplierOptions"
      :interest-type-options="interestTypeOptions"
      :allow-to-leave.sync="allowToLeave"
      @refetch-data="refetchData"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted, computed, watch } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import contractStoreModule from "../contractStoreModule";
import ContractScheduleEditTabInformation from "./ContractScheduleEditTabInformation.vue";
import loanStoreModule from "@/views/loan/loanStoreModule";
import { useStore } from 'vuex'

export default {

  components: {
    ContractScheduleEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  beforeRouteLeave(to, from, next) {
    // show your modal or prompt here
    // call next() to allow the user to leave
    // or call next(false) to prevent the user from leaving
    if(!this.allowToLeave){
       this.$swal({
        title: "確定離開頁面?",
        text: "你不能再獲得所有未保存的數據！",
        showCancelButton: true,
        confirmButtonText: "離開",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
            next();
        }
      })
    }else{
      next();
    }
  },
  setup() {
    const contractData = ref({ contracts: [{ id: "0" }] });
    const allowToLeave = ref(false)
    const CONTRACT_APP_STORE_MODULE_NAME = "app-contract";
    const LOAN_APP_STORE_MODULE_NAME = "app-loan";

    const contract = {
      id: 0,
      contract_number: "",
      loan_type_id: null,
      supplier_create_id: null,
      supplier_name_cn: null,
      supplier_name_en: null,
      moneylender_number: null,
      supplier_address: null,
      contact_name:null,
      name_cn: null,
      name_en: null,
      id_number: null,
      br_number: null,
      //get today date
      loan_date: new Date().toISOString().slice(0, 10),
      amount: null,
      interest_type_id: null,
      period: null,
      is_monthly: 1,
      first_pay_date: null,
      annual_interest_rate: null,
      pay_date: null,
      loan_information: {
        application_date: null,
        loan_purpose: null,
        customer_source: null,
        date_of_birth: null,
        gender_id: null,
        mobile: null,
        tel: null,
        address: null,
        rent_or_mortagage: null,
        living_expenses: null,
        company_name: null,
        company_address: null,
        position: null,
        work_age: null,
        payment_method: null,
        pt_company_name: null,
        pt_company_address: null,
        pt_position: null,
        pt_work_age: null,
        pt_payment_method: null,
        monthly_salary: null,
        pt_monthly_salary: null,
        histories: [],
        schedules: [],
        average_amount: null,
        total_amount: null,
      },
    };


    if (!store.hasModule(CONTRACT_APP_STORE_MODULE_NAME))
      store.registerModule(CONTRACT_APP_STORE_MODULE_NAME, contractStoreModule);
    if (!store.hasModule(LOAN_APP_STORE_MODULE_NAME))
      store.registerModule(LOAN_APP_STORE_MODULE_NAME, loanStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CONTRACT_APP_STORE_MODULE_NAME))
        store.unregisterModule(CONTRACT_APP_STORE_MODULE_NAME);
      if (store.hasModule(LOAN_APP_STORE_MODULE_NAME))
        store.unregisterModule(LOAN_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
        store
          .dispatch("app-contract/fetchContract", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            contractData.value = response.data.contract;
          })
          .catch((error) => {
            console.log("error when fetching contract", error);
            if (error.response.status === 404) {
              contractData.value = undefined;
            }
          });
      
    };

    onMounted(() => {
      refetchData();
      refetchOption();
    });

    const supplierOptions = ref([]);
    const interestTypeOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          suppliers: true,
          interest_type: true,
        })
        .then((response) => {
          supplierOptions.value = response.data.suppliers;
          interestTypeOptions.value = response.data.interest_types;
        });
    };

    return {
      contractData,
      supplierOptions,
      interestTypeOptions,
      refetchData,
      refetchOption,
      allowToLeave,
    };
  },
};
</script>
